import React from 'react'

const Footer = () => {
  return (
    <footer class="bg-white text-center py-4 text-gray-600 text-sm">
        SocraticAli Consultants© 2024 All Rights Reserved.
    </footer>
  )
}

export default Footer